import { useSetResizeData } from './useSetResizeData';
import { useGetGamesConfiguration } from '@interlayer/js/components/system/App/hooks/useGetGamesConfiguration/useGetGamesConfiguration';

export const useBeforeInitHooks = () => {
    useSetResizeData();
    useGetGamesConfiguration(true);
};
